import type { SmsMessage } from "@stockline/shared/types/communications/sms-message"
import type { OfflineResourceConfig } from "../../../types"
import { SMS_MESSAGE_TABLE } from "./db"

export const smsMessageConfig: OfflineResourceConfig<SmsMessage> = {
  name: "sms-messages",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  // ~0.9 KB/row (a 1000-row page is ~0.85 MB). Halve the page to keep each
  // server-side stringify short during cold-start.
  pageSize: 500,
  endpoints: {
    full: "/api/v2/sms-messages",
    delta: "/api/v2/sms-messages/changes",
    push: "/api/v2/sms-messages/changes",
  },
  tableName: SMS_MESSAGE_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    chatId: "chatId",
    status: "status",
    direction: "direction",
    timestamp: "timestamp",
    syncId: "syncId",
    "[chatId+timestamp]": "[chatId+timestamp]",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
